// Güvenli depo anahtar adları — tek kaynak (9.34 · D-605).
//
// Aynı adları hem keygen (`signalKeys.ts`) hem oturum yönetimi (`session.ts`)
// kullanıyor. İki yerde ayrı yazılsaydı yalnız şansla aynı kalırlardı (D-506);
// burada bir kez tanımlanıyor.
export const IDENTITY_SECRET = 'signal.identity.secret';
export const IDENTITY_PUBLIC = 'signal.identity.public';
export const REGISTRATION_ID = 'signal.registrationId';
// Cihazın anahtarları dizine bir kez yüklendi mi. İkinci bir tam kayıt,
// tek-kullanımlık prekey'leri yerelde ezip sunucuda eskileri bırakırdı.
export const KEYS_REGISTERED = 'signal.registered';
// Sunucunun bu kuruluma ayırdığı cihaz numarası (9.34 · D-618). Kimlik anahtarı
// cihazın kalıcı adı, bu ise dizindeki karşılığı; prekey sayımı kendi deposunu
// sorabilsin diye saklanıyor.
export const DEVICE_ID = 'signal.deviceId';
// Bir sonraki KULLANILMAMIŞ tek-kullanımlık prekey kimliği. Kimlikler asla
// tekrar edilmez: tekrar eden kimlik, sunucunun eski açık anahtarı dağıtmasına
// ve cihazdaki yeni özelin ona uymamasına yol açardı.
export const NEXT_PREKEY_ID = 'signal.nextPrekeyId';
export const signedPreKeySecret = (id: number): string => `signal.spk.${id}`;
export const oneTimePreKeySecret = (id: number): string => `signal.otp.${id}`;
// Oturum artık KİŞİ BAŞINA değil, CİHAZ BAŞINA (9.34 · D-625). Aynı kişinin iki
// cihazı ayrı ratchet durumu taşır; tek anahtarda tutmak, birinin ilerlemesini
// ötekinin üzerine yazmak olurdu.
export const session = (peerId: number, deviceId: number): string =>
  `signal.session.${peerId}.${deviceId}`;
// Bu KİŞİ için bugüne kadar görülen kimlik anahtarları (9.34 · D-634).
// Karşılaştırma dayanağı bu: listede olmayan bir anahtar çıkarsa, mesajlarımı
// okuyabilen yeni biri var demektir. Birim cihaz DEĞİL kişi — cihaz numaraları
// tekrar kullanılmadığı için yeniden kurulum "yeni cihaz" olarak görünüyor ve
// cihaz başına izleme onu hiç yakalayamazdı.
export const peerIdentities = (peerId: number): string => `signal.peerIdentities.${peerId}`;
// Sohbet başına kimlik değişikliği kaydı. Sohbette gösterilen satır bundan
// geliyor; sunucuda karşılığı YOK, çünkü "bu cihaz daha önce ne gördü"
// sorusunu yalnız cihaz yanıtlayabilir.
export const identityLog = (peerId: number): string => `signal.identityLog.${peerId}`;
// 9.34.3 / D-696 — bu cihazda doğrulanan güvenlik numarası (yalnız bu cihazda).
export const safetyVerification = (peerId: number): string => `signal.safetyVerified.${peerId}`;
